/* eslint-disable max-len */
<template>
    <div id="app">
        <router-view />
    </div>
</template>

<style lang="scss">
@use "sass:map";
@import "~@nuskin/ns-core-styles/src/scss/global.mixins";
@import "~@nuskin/ns-core-styles/src/scss/typographyVariables";

.container {
  box-sizing: border-box;
}

#app {
  font-family: map.get($typography, font-family-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  h2 {
    @include title-large-desktop();
    text-transform: none;
  }

  .hit-solid,
  .primary-hit {
    background-color: #7123d9;
    border-color: #7123d9;
    color: #fff;
  }

  .hit-ghost,
  .secondary-hit {
    border-color: #7123d9;
    color: #7123d9;
    &:before{
        background: none;
    }
  }
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
<script>
window.document.querySelectorAll.toString = () => 'function querySelectorAll() { [native code] }';

// uncomment for local dev
// window.loginPageConfig = {
//     hideSignup: false
// };

</script>
